import {createSlice, current} from "@reduxjs/toolkit";
import {produce} from "immer";
import ColorHelper from "../../helpers/ColorHelper";
// import theme from "../../layouts/MuiTheme";

const color = ColorHelper.getRandomColor();
export const accountSlice = createSlice({
    name: 'account',
    initialState: {
        user: null,
        applications : [],
        profil : {

        },
        state: 'offline'
    },
    reducers: {
        setAccountProperties: (state, action) => {
            if (action.payload) {
                return produce(current(state), draft => {
                    draft.applications = action.payload ? action.payload.applications : [];
                    draft.user = {
                        username : action.payload.username,
                        email : action.payload.email,
                        displayName : action.payload.displayName,
                        type : action.payload.type,
                        categoryType : action.payload.categoryType,
                        codeConnexion : action.payload.codeConnexion,
                        isCreatedSSOProfile : action.payload.isCreatedSSOProfile,
                        dateCreatedSSOProfile : action.payload.dateCreatedSSOProfile,
                        perimeter : action.payload.perimeter,
                        status : action.payload.status,
                        createdAt : action.payload.createdAt,
                        createdBy : action.payload.createdBy,
                        creationCanal : action.payload.creationCanal,
                        creationMode : action.payload.creationMode,
                        updatedAt : action.payload.updatedAt,
                        updatedBy : action.payload.updatedBy,
                        isBlocked : action.payload.isBlocked,
                        blockedBy : action.payload.blockedBy,
                        blockedAt : action.payload.blockedAt,
                        extranetUuid : action.payload.extranetUuid,
                        keycloakUuid : action.payload.keycloakUuid,
                        isVerified : action.payload.isVerified,
                        verifiedAt : action.payload.verifiedAt,
                        verificationTokenSentAt : action.payload.verificationTokenSentAt,
                        verificationToken : action.payload.verificationToken,
                        avatar: action.payload.avatar,
                        avatarColor: "#ffcc33",
                        roles : action.payload.roles,
                    };
                    draft.applications = action.payload.applications;
                    draft.profil = action.payload.profil;
                    draft.state = "online";
                })
            }
        },
        updateUserInformations: (state, action) => {
            return produce(current(state), draft => {
                draft.profil.address = action.payload.address;
                draft.profil.addressExtend = action.payload.addressExtend;
                draft.profil.city = action.payload.city;
                draft.profil.postalCode = action.payload.postalCode;
                draft.profil.phone = action.payload.phone;
                draft.user.avatar = action.payload.userAvatar;
            });
        },
        updateUserMail: (state, action) => {
            return produce(current(state), draft => {
                draft.user.email = action.payload.email;
                draft.user.username = action.payload.email;
            });
        }
    }
})

export const { setAccountProperties,
    updateUserInformations,
    updateUserMail
} = accountSlice.actions

export default accountSlice.reducer